import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_EA_CALENDAR_REQUEST',
  'GET_EA_CALENDAR_SUCCESS',
  'GET_EA_CALENDAR_ERROR'
);
